/**
 * Idle-gated falling cherry-blossom petals — a config of the shared
 * falling-particle effect. Big 5-petal blossoms drift down slowly, swaying and
 * tumbling. Color follows the `--petal-fill` theme var (pink in light, a lighter
 * pink at dusk).
 */
import { createFallingEffect } from './createFallingEffect';

const FALLBACK_FILL = 'oklch(0.82 0.09 350)';

/** Draw a 5-petal blossom centered at the origin (engine sets fill + transform). */
function drawBlossom(ctx: CanvasRenderingContext2D, size: number): void {
  for (let i = 0; i < 5; i++) {
    ctx.save();
    ctx.rotate((i * Math.PI * 2) / 5);
    ctx.beginPath();
    ctx.ellipse(0, -size * 0.55, size * 0.3, size * 0.5, 0, 0, Math.PI * 2);
    ctx.fill();
    ctx.restore();
  }
}

/** Full-screen idle cherry-blossom petals. */
export const PetalsOverlay = createFallingEffect({
  testId: 'petals-overlay',
  config: {
    count: 55,
    size: [14, 22],
    speed: [0.4, 0.9], // slow, gentle drift
    drift: [-0.3, 0.3],
    sway: [10, 26],
    swayFreq: [0.01, 0.025],
    spin: [-0.02, 0.02],
    alpha: [0.75, 1],
  },
  fill: canvas => getComputedStyle(canvas).getPropertyValue('--petal-fill').trim() || FALLBACK_FILL,
  draw: drawBlossom,
});
